import React from 'react';

const SECTIONS = [
    'Авторські права на Платформі',
    'Що забороняється завантажувати',
    'Модерація контенту',
    'Процедура подачі скарги (DMCA)',
    'Форма скарги',
    'Зустрічне повідомлення',
    'Повторні порушники',
    'Верифікація артистів та "Claim Your Music"',
];

export default function CopyrightContentUk() {
    return (
        <div className="lp-content">
            {/* ── Table of contents ── */}
            <nav className="lp-toc" aria-label="Зміст">
                <p className="lp-toc-title">Зміст</p>
                <ol className="lp-toc-list">
                    {SECTIONS.map((title, i) => (
                        <li key={i}>
                            <a href={`#s${i + 1}`} className="lp-toc-link">
                                <span className="lp-toc-num">{i + 1}.</span>
                                {title}
                            </a>
                        </li>
                    ))}
                </ol>
            </nav>

            <div className="lp-highlight">
                <strong>Важливо:</strong> Knitly поважає інтелектуальну власність і очікує того самого від своїх користувачів. Ми активно боремось з піратством та маємо прозору процедуру подачі скарг згідно з нормами DMCA.
            </div>

            {/* 1 */}
            <section id="s1" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">1</span>
                    <h2 className="lp-section-title">Авторські права на Платформі</h2>
                </div>
                <p>
                    Весь контент, опублікований користувачами на Knitly, залишається власністю відповідних авторів та правовласників. Knitly не претендує на права власності на контент, завантажений користувачами.
                </p>
                <p>
                    Дизайн, логотип, назва «Knitly», інтерфейс та інші елементи Платформи є інтелектуальною власністю Knitly та захищені законодавством України та міжнародними договорами.
                </p>
                <p>
                    Knitly виступає як «хостинг-провайдер» (принцип "Safe Harbor" за DMCA та Законом України «Про авторське право»). Ми не несемо відповідальності за контент, завантажений третіми особами, за умови нашого оперативного реагування на законні скарги правовласників.
                </p>
            </section>

            {/* 2 */}
            <section id="s2" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">2</span>
                    <h2 className="lp-section-title">Що забороняється завантажувати</h2>
                </div>
                <p>Без дозволу правовласника суворо забороняється завантажувати:</p>
                <ul>
                    <li>Пісні, альбоми або їх частини, права на які належать іншим особам.</li>
                    <li>Ремікси, кавер-версії без відповідної ліцензії.</li>
                    <li>Музичні відео або аудіовізуальні твори без прав на дистрибуцію.</li>
                    <li>Будь-який контент із видаленими або зміненими відомостями про авторство.</li>
                </ul>
                <div className="lp-warning">
                    <strong>Зверніть увагу:</strong> Зміна назви треку, модифікація висоти тону (pitch shifting), додавання тиші або шуму на початку/кінці — не знімає обмежень авторського права. Системи розпізнавання виявляють такий контент.
                </div>
            </section>

            {/* 3 */}
            <section id="s3" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">3</span>
                    <h2 className="lp-section-title">Модерація контенту</h2>
                </div>
                <p>
                    Knitly застосовує багаторівневий підхід до виявлення потенційно порушуючого авторські права контенту:
                </p>
                <ul>
                    <li><strong>Система скарг:</strong> правовласники та користувачі можуть повідомляти про порушення через кнопку «Поскаржитись» або email.</li>
                    <li><strong>Ручна модерація:</strong> команда Knitly перевіряє позначений контент та реагує відповідно до цієї Політики.</li>
                    <li><strong>Автоматизовані інструменти:</strong> у міру розвитку платформи ми впроваджуємо засоби автоматичного виявлення захищеного контенту.</li>
                </ul>
                <p>
                    Якщо ваш оригінальний контент позначено помилково, ви можете оскаржити це рішення через <a href="mailto:copyright@knitly.app">copyright@knitly.app</a>.
                </p>
            </section>

            {/* 4 */}
            <section id="s4" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">4</span>
                    <h2 className="lp-section-title">Процедура подачі скарги (DMCA)</h2>
                </div>
                <p>
                    Якщо ви є правовласником або уповноваженим представником та вважаєте, що ваш контент опубліковано без дозволу, ви можете подати офіційне повідомлення про порушення авторських прав (DMCA Takedown Notice).
                </p>
                <p><strong>Ваше повідомлення повинно містити:</strong></p>
                <ol>
                    <li>Ваше ім'я та контактну інформацію (email, телефон або адреса).</li>
                    <li>Ідентифікацію захищеного твору, права на який порушено.</li>
                    <li>Посилання на конкретний матеріал, що порушує права, на Knitly.</li>
                    <li>Заяву про те, що ви є правовласником або уповноваженою особою.</li>
                    <li>Заяву про добросовісність: «Я добросовісно вважаю, що використання зазначеного матеріалу не є дозволеним правовласником».</li>
                    <li>Фізичний або електронний підпис.</li>
                </ol>
                <div className="lp-info">
                    Ми розглянемо скаргу протягом <strong>5 робочих днів</strong> та повідомимо вас про прийняте рішення. При задоволенні скарги контент видаляється.
                </div>
            </section>

            {/* 5 */}
            <section id="s5" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">5</span>
                    <h2 className="lp-section-title">Форма скарги</h2>
                </div>
                <p>
                    Скарги щодо авторських прав надсилайте на:{' '}
                    <a href="mailto:copyright@knitly.app">copyright@knitly.app</a>
                </p>
                <p>
                    Також ви можете скористатись кнопкою <strong>«⚠️ Поскаржитись»</strong>, яка знаходиться під кожним треком або постом.
                </p>
                <div className="lp-highlight">
                    <strong>Шаблон повідомлення:</strong><br /><br />
                    Я, [ваше ім'я], правовласник / уповноважений представник [назва організації], цим повідомляю, що трек за посиланням [URL] порушує авторські права на твір [назва твору]. Прошу видалити зазначений матеріал. Я добросовісно вважаю, що це використання не дозволено. Інформація в цьому повідомленні є точною.
                </div>
                <div className="lp-warning">
                    <strong>Увага:</strong> Свідомо неправдиве повідомлення загрожує юридичною відповідальністю (ст. 512(f) DMCA).
                </div>
            </section>

            {/* 6 */}
            <section id="s6" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">6</span>
                    <h2 className="lp-section-title">Зустрічне повідомлення</h2>
                </div>
                <p>
                    Якщо ваш контент було видалено внаслідок скарги, яку ви вважаєте помилковою, ви можете подати зустрічне повідомлення (Counter-Notice). Воно повинно містити:
                </p>
                <ol>
                    <li>Ваші контактні дані.</li>
                    <li>Ідентифікацію видаленого матеріалу та його URL.</li>
                    <li>Заяву під присягою про те, що матеріал було видалено помилково (наприклад, ви маєте ліцензію або це Fair Use).</li>
                    <li>Згоду на юрисдикцію відповідного суду.</li>
                    <li>Ваш підпис.</li>
                </ol>
                <p>
                    Після отримання зустрічного повідомлення ми проінформуємо особу, яка подала скаргу. Якщо протягом 10-14 днів вона не подасть позов до суду, контент буде відновлений.
                </p>
            </section>

            {/* 7 */}
            <section id="s7" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">7</span>
                    <h2 className="lp-section-title">Повторні порушники (Repeat Infringers)</h2>
                </div>
                <p>
                    Згідно з нашою політикою, Knitly блокує користувачів, які систематично порушують авторські права:
                </p>
                <ul>
                    <li><strong>1-е порушення (Страйк 1):</strong> видалення контенту + офіційне попередження.</li>
                    <li><strong>2-е порушення (Страйк 2):</strong> видалення контенту + тимчасове блокування завантажень (30 днів).</li>
                    <li><strong>3-є порушення (Страйк 3):</strong> перманентне блокування облікового запису.</li>
                </ul>
            </section>

            {/* 8 */}
            <section id="s8" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">8</span>
                    <h2 className="lp-section-title">Верифікація артистів та «Claim Your Music»</h2>
                </div>
                <p>
                    Верифіковані артисти на Knitly мають доступ до розширених інструментів управління своїм контентом:
                </p>
                <ul>
                    <li>
                        <strong>«Заявити права на музику»</strong> — якщо ваші треки були завантажені іншими сервісом, ви можете заявити на них права, перенести у свій профіль або дати команду на видалення.
                    </li>
                    <li>
                        <strong>Пріоритетна модерація</strong> — скарги верифікованих артистів розглядаються поза чергою.
                    </li>
                </ul>
                <p>
                    Щоб пройти верифікацію, надішліть запит на <a href="mailto:verify@knitly.app">verify@knitly.app</a>.
                </p>
            </section>

            {/* Contact */}
            <div className="lp-contact-card">
                <h3>Запити щодо авторських прав</h3>
                <p>
                    Скарги на порушення: <a href="mailto:copyright@knitly.app">copyright@knitly.app</a><br />
                    Верифікація артистів: <a href="mailto:verify@knitly.app">verify@knitly.app</a><br />
                    Термін розгляду: до 5 робочих днів.
                </p>
            </div>
        </div>
    );
}
